<div id="delegation">
  <p class="TXT_TITLE">:: {{ constants.listsOfDelegation }} ::</p>
  <form [formGroup]="delegationForm" (ngSubmit)="searchDelegation('submit')">
    <div nz-row>
      <div nz-col nzSpan="2">
        <label>{{ constants.startDate }}: </label>
      </div>
      <div nz-col nzSpan="6">
        <nz-date-picker
          formControlName="startDate"
          [nzPlaceHolder]="'Start Date'"
        ></nz-date-picker>
      </div>
    </div>

    <div nz-row>
      <div nz-col nzSpan="2">
        <label>{{ constants.endDate }}:</label>
      </div>
      <div nz-col nzSpan="6">
        <nz-date-picker
          formControlName="endDate"
          [nzPlaceHolder]="'End Date'"
        ></nz-date-picker>
      </div>
    </div>

    <button type="submit" nz-button nzType="primary">
      {{ constants.search }}
    </button>
  </form>

  <div class="delegation-actions">
    <button nz-button nzType="default" (click)="onAddItem()">
      <img
        class="iconImage"
        src="../../../../assets/icons/new.gif"
        alt="New Item Icon"
      />
      <span class="textColor ml">{{ constants.addNewDelegation }}</span>
    </button>

    <button nz-button nzType="default" (click)="onDeleteItem()">
      <img
        class="iconImage"
        src="../../../../assets/icons/del.gif"
        alt="Delete Icon"
      />
      <span class="textColor ml">{{ constants.deleteSelectedDelegation }}</span>
    </button>
  </div>

  <nz-table
    #delegationsData
    class="StyleTable"
    [nzData]="delegations"
    nzBordered
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="[10, 20, 50, 100]"
    (nzPageSizeChange)="onPageSizeChange($event)"
    (nzPageIndexChange)="onPageIndexChange($event)"
    [nzNoResult]="customNoDataMessage"
  >
    <thead>
      <tr>
        <th></th>
        <th>{{ constants.delegatorUser }}</th>
        <th>{{ constants.delegateeUser }}</th>
        <th>{{ constants.period }}</th>
        <th>{{ constants.delegationBy }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of delegationsData.data; let i = index">
        <td>
          <input
            type="checkbox"
            [(ngModel)]="item.selected"
            name="selected_{{ i }}"
          />
        </td>
        <td class="text-left">{{ item.delFrom }}</td>
        <td class="text-left">{{ item.delThrough }}</td>
        <td>
          {{ item.delDateFrom | date : "dd-MMM-yyyy" }} to
          {{ item.delDateThrough | date : "dd-MMM-yyyy" }}
        </td>
        <td class="text-left">{{ item.delBy }}</td>
      </tr>
    </tbody>
  </nz-table>
</div>
